/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftControllerDtoNftGenerateListRequest model module.
 * @module model/NftControllerDtoNftGenerateListRequest
 * @version 1.0
 */
class NftControllerDtoNftGenerateListRequest {
    /**
     * Constructs a new <code>NftControllerDtoNftGenerateListRequest</code>.
     * @alias module:model/NftControllerDtoNftGenerateListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        NftControllerDtoNftGenerateListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>NftControllerDtoNftGenerateListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftControllerDtoNftGenerateListRequest} obj Optional instance to populate.
     * @return {module:model/NftControllerDtoNftGenerateListRequest} The populated <code>NftControllerDtoNftGenerateListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftControllerDtoNftGenerateListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftControllerDtoNftGenerateListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftControllerDtoNftGenerateListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of NftControllerDtoNftGenerateListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

NftControllerDtoNftGenerateListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
NftControllerDtoNftGenerateListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
NftControllerDtoNftGenerateListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
NftControllerDtoNftGenerateListRequest.prototype['skip'] = undefined;






export default NftControllerDtoNftGenerateListRequest;

